import { DisplayAdsService } from "@adfenix/types";
import { SERVICES_URL, handleError } from "api/helper";

import { del, get, post, put } from "api/http";

const baseUrl = `${SERVICES_URL}/display-ads/auth/v1`;

export const getDisplayAdTemplates = (): Promise<
  DisplayAdsService.CampaignTemplates[]
> => get(`${baseUrl}/template`).catch(handleError);

export const getDisplayAdSettingsForHq = (
  hqId: string | undefined
): Promise<DisplayAdsService.DeltaTemplateSettingModel[]> =>
  get(`${baseUrl}/delta-template-setting/${hqId}`).catch(handleError);

export const updateDisplayAdSetting = (
  settings: DisplayAdsService.DeltaTemplateSettingModel
) => put(`${baseUrl}/delta-template-setting`, settings).catch(handleError);

export const createDisplayAdSetting = (
  settings: DisplayAdsService.DeltaTemplateSettingModel
) => post(`${baseUrl}/delta-template-setting`, settings).catch(handleError);

export const deleteDisplayAdSetting = (
  settings: DisplayAdsService.DeltaTemplateSettingModel
) => del(`${baseUrl}/delta-template-setting`, settings).catch(handleError);
